import React from 'react';
import paper from '../ReportPaper.module.css';
import GrowthChartPanel from '../../../../pages/appointment/components/growthCurve/GrowthChartPanel';
import GrowthHistoryTable from '../../../../pages/appointment/components/growthCurve/GrowthHistoryTable';
import growthStyles from '../../../../pages/appointment/components/growthCurve/growthCurve.module.css';
import { WHO_ATTRIBUTION, sexFromGender } from '../../../../pages/appointment/modules/growth/growthIndicators';
import { indicatorSeries, indicatorsWithData } from '../../../../pages/appointment/modules/growth/growthSeries';

/**
 * Miolo do PDF da curva de crescimento: um gráfico em percentis por indicador
 * com medição e, abaixo, o histórico com percentil e escore-z. O gráfico é SVG
 * só com traços e texto (o html2canvas não desenha imagem dentro de SVG).
 *
 * `statsList`: saída de growthStatsList; `gender`: do cadastro;
 * `markers`: idades (meses) das medições da assimetria craniana.
 */
const GrowthCurveReportBody = ({ statsList, gender, markers }) => {
  const sex = sexFromGender(gender);
  const indicators = indicatorsWithData(statsList);

  return (
    <>
      {indicators.map((indicator) => (
        <div key={indicator.key} className={paper.section}>
          <div className={paper.sectionTitle}>{indicator.label}</div>
          <GrowthChartPanel
            series={indicatorSeries(statsList, indicator)}
            sex={sex}
            mode="percentile"
            markers={indicator.key === 'head' ? markers : []}
            height={260}
          />
        </div>
      ))}

      <div className={paper.section}>
        <div className={paper.sectionTitle}>Histórico de medições</div>
        <GrowthHistoryTable statsList={statsList} classes={{ table: paper.table, num: paper.num }} />
      </div>

      <span className={growthStyles.attribution}>{WHO_ATTRIBUTION}</span>
    </>
  );
};

export default GrowthCurveReportBody;
